// AUTO-GENERATED from docs/docs/fastlane/user-support/fastlane-user-manual-combined.md.
// Do not edit by hand. Re-run scripts/generate-user-guide-sections.py.


import { BlockOutlined } from "@ant-design/icons";
import type { Section } from "../../types";
import img1 from "../../images/main/workholding-versabuilt/workholding-multigrip.png";
import img2 from "../../images/main/workholding-versabuilt/versabuilt-mill-automation.png";

export const workholding_versabuiltSection: Section = {
	key: "workholding-versabuilt",
	label: "Setting Up Workholding and Mill Automation",
	icon: BlockOutlined,
	intro: "Two related screens for CAM programmers and shop managers: physical fixturing inventory and the mill-automation systems that load parts into machines unattended.",
	blocks: [
		{ type: "heading", level: 3, text: "8.1 Tracking Workholding Fixtures" },
		{ type: "image", src: img1, alt: "Workholding MultiGrip" },
		{ type: "paragraph", text: "This screen tracks vise/jaw/fixture inventory and assignments — primarily MultiGrip configurations. Use it when you're looking for the right fixture for a job or auditing what's tied up in current setups." },
		{ type: "heading", level: 3, text: "8.2 Reviewing VersaBuilt Mill Automation" },
		{ type: "image", src: img2, alt: "VersaBuilt Mill Automation" },
		{ type: "paragraph", text: "The VersaBuilt page surfaces mill-automation system configurations and the parts each system is currently running. Use it when you need to see what's running on the unattended mills overnight or when you're configuring a new automation cell." },
		{ type: "heading", level: 3, text: "8.X Troubleshooting Workholding" },
		{ type: "paragraph", text: "TODO: pending input from CAM Programmers on common pitfalls (vise misallocation, fixture conflicts)." },
	],
};

export default workholding_versabuiltSection;
